/** Shared TopBanner loading placeholders — V3 rounded bars, no bg-light cards. */
export const TopBannerSkeleton = () => (
  <div className="my-3 placeholder-glow" aria-hidden="true">
    <div className="row row-cols-1 row-cols-lg-2 g-3">
      <div className="col">
        <span
          className="placeholder rounded col-5 d-block mb-3"
          style={{ height: '1.25rem' }}
        />
        <div className="d-flex align-items-center mb-3 gap-3">
          <span
            className="placeholder rounded flex-shrink-0"
            style={{ width: 64, height: 40 }}
          />
          <span
            className="placeholder rounded col-6"
            style={{ height: '1.1rem' }}
          />
        </div>
        <div className="text-end">
          <span
            className="placeholder rounded col-3 d-inline-block"
            style={{ height: '0.9rem' }}
          />
        </div>
      </div>
      <div className="col">
        <span
          className="placeholder rounded d-block w-100"
          style={{ height: '12rem' }}
        />
      </div>
    </div>
  </div>
);
